import axios from "../../../../axios";
import Cookies from "js-cookie";

export const CGetAllShortlistCandidates = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("api/Consultant/GetShortlistedCandidate", {
    token,
  });
};